// import Vue from 'vue';
// import moment from 'moment';
// import momentTimeZone from 'moment-timezone';
// import 'moment/locale/zh-cn';
// import 'moment/locale/en-au';
// import 'moment/locale/fr';
// import {
//   VSF_LOCALE_COOKIE
// } from '@vue-storefront/core';
export default ({
  app
}) => {
  if (!app.getCuurentDate) {
    app.getCuurentDate = (currentTime) => {
      // 创建一个表示标准时间的 Date 对象
      if (currentTime) {
        const standardTime1 = new Date(currentTime.replace(/-/g, '/'));
        // 获取浏览器时区的偏移量（以分钟为单位）
        const offsetMinutes = new Date().getTimezoneOffset();
        // 计算浏览器时区的时间
        const standardTime = new Date(standardTime1.getTime() - (offsetMinutes * 60 * 1000));

        // 获取年、月、日、小时、分钟和秒
        const year = standardTime.getFullYear();
        const month = String(standardTime.getMonth() + 1).padStart(2, '0');
        const day = String(standardTime.getDate()).padStart(2, '0');
        const hours = String(standardTime.getHours()).padStart(2, '0');
        const minutes = String(standardTime.getMinutes()).padStart(2, '0');
        const seconds = String(standardTime.getSeconds()).padStart(2, '0');

        // 格式化时间
        const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        return formattedTime;
      } else {
        return currentTime;
      }
    };
  }
};
